import { useSelector } from "react-redux";

export function useHasPermission(required) {
  const user = useSelector((state) => state.user.user);
  if (!required) return true;

  return Array.isArray(user?.permissions) && user.permissions.includes(required);
};

export default useHasPermission;